<ng-container *ngIf="{ state: state$ | async, sharedDataState: sharedDataState$ | async } as s">

    <div class="planned-purchase-price-container mat-elevation-z8">
        <div class="planned-purchase-price-table-header">
            <mat-generic-input (inputFormGroupChange)="formgroupChange($event)" [fields]="layout.filterFields"></mat-generic-input>

            <div class="action-buttons">
                <button mat-mini-fab
                        (click)="openGenerateDialog()"
                        color="primary"
                        matTooltip="{{ 'app.page.planned-purchase-price.actions.generate.label' | translate }}">
                    <mat-icon>sync</mat-icon>
                </button>
                <button mat-mini-fab
                        (click)="openAddDialog()"
                        color="primary"
                        matTooltip="{{ 'app.page.planned-purchase-price.actions.add.label' | translate }}">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="s.state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-purchase-price.articleNr.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ s.sharedDataState.articleLookup[element.articleId]?.articleNr }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="article">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-purchase-price.article.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ s.sharedDataState.articleLookup[element.articleId]?.name }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="measureUnit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-purchase-price.measure-unit.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{s.sharedDataState.measureUnitLookup[s.sharedDataState.articleLookup[element.articleId]?.baseMeasureUnitId]?.name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="validFrom">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-purchase-price.from.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.validFrom | date: 'dd.MM.yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="validTo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.planned-purchase-price.to.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.validTo | date: 'dd.MM.yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="priceCt">
                    <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.planned-purchase-price.priceCt.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.priceCt / 100 | currency:'EUR':'symbol':'1.2-2' }}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="actions-column">
                        <button mat-icon-button
                                color="primary"
                                matTooltip="{{ 'app.page.planned-purchase-price.actions.edit.label' | translate }}"
                                (click)="openAddDialog(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.planned-purchase-price.actions.delete.label' | translate }}"
                                (click)="onDelete(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: layout.columns;"></tr>
            </table>
        </div>
        <mat-paginator [pageSize]="20" [pageSizeOptions]="[20, 50]"></mat-paginator>
    </div>

</ng-container>
